// custom blog data

export const blogData = [
  {
    _id: "d5c17d84f0bd",
    title: "Different Ways of Writing Method Arguments in Ruby",
    brief:
      "There are various ways to pass arguments to methods in ruby and in this article I will talk about 4 ways: 1. Basic Argument Syntax, 2. Named Arguments, 3. Default argument values and Splat arguments....",
    slug: "different-ways-of-writing-method-arguments-in-ruby",
    dateAdded: "2022-10-23T23:11:12.427Z",
    totalReactions: 1,
    coverImage: "https://miro.medium.com/max/828/1*E7zkYHUJb14Ml2pZzrd_3A.webp",
    url: "https://medium.com/@natashachirombe/different-ways-of-writing-method-arguments-in-ruby-d5c17d84f0bd",
  },
  {
    _id: "99c38cd1d49b",
    title:
      "The biggest challenges that I have faced so far in my software development journey .",
    brief:
      "Introduction\nA lot of React developers are big fans of using Redux in their projects in order to make the development of their App much more easier and constructive, but many people who are new to React believe that it is an official React library wh...",
    slug: "is-redux-toolkit-a-react-library",
    dateAdded: "2022-06-11T17:53:18.447Z",
    totalReactions: 1,
    coverImage: "https://miro.medium.com/max/828/1*S_Xn_WHk7P7EkFlfmYJkmw.webp",
    url: "https://medium.com/@natashachirombe/what-have-been-the-biggest-challenges-that-you-have-faced-so-far-in-your-journey-with-software-99c38cd1d49b",
  },
];
